export const locale = document.documentElement.lang === 'en' ? 'en-US' : 'ja';

export const NAVIGATE_EVENT = 'onnavigate';
export const PHYSICS_NAVIGATE_EVENT = 'onphysicsnavigate';
export const REQUEST_DATA_EVENT = 'ondatarequested';

export const CANVAS_SCALE = 2;

export const isMobile = () => {
  return window.innerWidth < 600 || window.innerHeight < 600;
};

export const intlPath = (path: string) => {
  const lang = document.documentElement.lang;
  return `/intl/${lang}${path}`;
};
